import ronin_chain from '../../styles/assets/chain/ronin.png';
import matic_chain from '../../styles/assets/chain/matic.png';
import eth_chain from '../../styles/assets/chain/eth.png';
import btx_locked from '../../styles/assets/btx_locked.svg';
import btx_unlocked from '../../styles/assets/btx_unlocked.svg';
import React, { useEffect, useState } from "react";

import VideoThumbnail  from '../uiComponents/VideoThumbnailComponent';

export default function TokenListThumnailImageComponent(props:any){
    //check if imageUri is actually a video by fileType
    if(props.item.symbol === 'BTX (Lock)'){
        return (
            <div style={{position: 'relative'}}>
              <img style={{width: 36, height: 36}} src={btx_locked} alt='logo of token' />
            </div>
        )
    }

    if(props.item.symbol === 'BTX (Unlocked)'){
        return (
            <div style={{position: 'relative'}}>
              <img style={{width: 36, height: 36}} src={btx_unlocked} alt='logo of token' />
            </div>
        )
    }
    if(!props.item.imageUri){
        return <></>
    }
    
    let isVideo = false;
    
    if(props.item.imageUri){
        let fileType = props.item.imageUri.split('.').pop();
        // remove the ? at the end aswell
        if(fileType === 'mp4'){
            isVideo = true;
        }
    }
    
    if(isVideo){
        return (
            <div style={{position: 'relative'}}>
              <VideoThumbnail
                  width={36}
                  height={36}
                  videoFilePath={props.item.imageUri}
              />
            </div>
        )
    }
    
    
    
    return (
        <>
        {props.item.imageUri && <div style={{position: 'relative'}}>
            <img style={{width: 36, height: 36}} src={props.item.imageUri} alt='logo of token' />
            {props.item.chain === 'ronin' && <img src={ronin_chain} style={{width: 18, position: 'absolute', right: -4, bottom: 0}} />}
            {props.item.chain === 'matic' && <img src={matic_chain} style={{width: 18, position: 'absolute', right: -4, bottom: 0}} />}
            {props.item.chain === 'mainnet' && <img src={eth_chain} style={{width: 18, position: 'absolute', right: -4, bottom: 0}} />}
          </div>
          }
        </>
    );
}
